export const EVENTQ_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const EVENTQ_EMAIL_INVALID_MESSAGE = 'Enter a valid email address';

export function isEventqEmail(value: string): boolean {
  return EVENTQ_EMAIL_PATTERN.test(value.trim());
}
